module.exports = __webpack_public_path__ + "static/media/viveka-world.c68baa3e.png";